import { call, put, takeEvery } from 'redux-saga/effects'
import { getQMSDashboardData_API} from '../../../../Config/Api';
import { createNotification } from '../../../../Config/NotificationToast';
import { logOut } from "../../../../utils/Helper";
import { instance } from "../../../auth/axiosInstance";

export default function* qmsDashboard() {
    yield takeEvery('GET_QMS_DASHBOARD_DATA', getQMSDashboardDataSaga);
}

const getQMSDashboardData = async (data) => {
    try {
        const response = await instance.get(`${getQMSDashboardData_API}?filter_month=${data.month?.toString()?.padStart(2, '0')}&filter_year=${data.year}${data?.downloadExcel ? `${'&download_excel=true'}`: ''}`, {
            ...(data.downloadExcel && {responseType: 'arraybuffer'})
        });
        return response;
    } catch (errors) {
        console.log("errors", errors);

        if (errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}


function* getQMSDashboardDataSaga(action) {
    try {
        const response = yield call(getQMSDashboardData, action.data);
        if (response instanceof ArrayBuffer) {
            action.data?.onSuccessCallback(response)
            yield put({ type: 'GET_QMS_DASHBOARD_DATA_SUCCESS', payload: {downloadExcel: true}});
        }else if (response.statusCode === 200) {
            yield put({ type: 'GET_QMS_DASHBOARD_DATA_SUCCESS', qmsDashboardDataRes: response.data });
        } else {
            if (response.statusCode === 401) {
                logOut('error', response.message)
            } else {
                createNotification('error', response.message);
                yield put({ type: 'GET_QMS_DASHBOARD_DATA_FAILURE', message: response.message, payload: {downloadExcel: true} });
            }
        }

    } catch (e) {
        yield put({ type: 'GET_QMS_DASHBOARD_DATA_FAILURE', message: "", payload: {downloadExcel: true} });
    }
}
